import React, { Component, Fragment } from 'react'
import Link from 'gatsby-link'
import * as R from 'ramda'
import { indexMap } from '@helpers'
import PageWrap from '@components/PageWrap'
import { pageRoute } from '@constants/routes'
import './Breadcrumbs.module.scss'

class Breadcrumbs extends Component {
  cleanText = (text) => text.replace(/-/g, ' ')

  checkIfShouldBeIgnored = (ignoreList, last) => R.includes(item => R.equals(item, last), ignoreList)

  getParentSlugs = (place) => {
    const { location } = this.props
    const indexForEach = R.addIndex(R.forEach)
    const links = location.pathname.split('/')
    let cleanLinks = R.filter(Boolean, links)
    let slug = ''

    indexForEach((link, index) => {
      if (index < place) {
        slug += `${link}/`
      }
    }, cleanLinks)

    return slug
  }

  renderLinkedBreadcrumbs = (data) => indexMap((item, index) => {
    let slug = item

    if (index >= 1) {
      slug = this.getParentSlugs(index)
      slug += `${item}`
    }

    if (item) {
      return (
        <Fragment key={`item-${index}`}>
          <Link to={pageRoute(slug)} styleName='link'>{this.cleanText(item)}</Link>
          &nbsp;<span>/</span>&nbsp;
        </Fragment>
      )
    }
  }, data)

  renderCurrentBreadcrumb = (item) => {
    return <span styleName='current'>{this.cleanText(item)}</span>
  }

  render () {
    const { ignoreList, location } = this.props
    const links = location.pathname.split('/')
    const cleanLinks = R.filter(Boolean, links)
    const last = cleanLinks.pop()

    if (this.checkIfShouldBeIgnored(ignoreList, last) || R.equals(location.pathname, '/') || R.includes('case-studies', location.pathname) || R.includes('our-suppliers', location.pathname) || R.includes('sustainability-at-bss', location.pathname)) {
      return null
    }

    return (
      <PageWrap nopadding>
        <div styleName='container'>
          {this.renderLinkedBreadcrumbs(cleanLinks)}
          {last && this.renderCurrentBreadcrumb(last)}
        </div>
      </PageWrap>
    )
  }
}

export default Breadcrumbs



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/Breadcrumbs.js